import { createSelector } from 'reselect';

const coreUsuariosSelector = state => state.core.usuarios;
const coreTiendasSelector = state => state.core.tiendas;

export const usuariosMappedByIdSelector = createSelector(
  [coreUsuariosSelector, coreTiendasSelector],
  (usuarios, tiendas) => {
    const usuariosMappedById = {};
    usuarios.forEach((usuario) => {
      const { id, tienda_id } = usuario;
      const tienda = tiendas.find(tienda => tienda.id === tienda_id);
      usuariosMappedById[id] = {...usuario, tienda };
    });
    return usuariosMappedById;
  },
);

export const usuariosActivosSelector = createSelector(
  [coreUsuariosSelector],
  usuarios => usuarios.filter(usuario => usuario.inactivo === false),
);
